import React, { useState, useEffect } from "react";

import NuxeoClient from "../../clients/NuxeoClient";
import Autocomplete from "../ui/Autocomplete";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function Licensee(props) {
  const appText = useI18n();
  const [timeID, setTimeID] = useState([]);

  useEffect(() => {
    _loadLicenseesDetails("", true);
  }, []);

  async function _loadLicenseesDetails(input = "", setLicensee = false) {
    await NuxeoClient.instance()
      .fetchLicensees(input)
      .then((response) => {
        props.handleChange("fetchedLicensees", response.entries);
        if (setLicensee) {
          props.handleChange("licensee", response.entries[0].title);
          props.handleChange("licenseeID", response.entries[0].uid);
          props.handleChange("licenseePath", response.entries[0].path);
          props.handleChange(
            "licenseeCode",
            response.entries[0].properties["licensee:licenseeCode"]
          );
        }
      });
  }

  const loadData = (input) => {
    setTimeID((timeID) => [
      ...timeID,
      setTimeout(() => _loadLicenseesDetails(input), 2000),
    ]);
    timeID.forEach((time) => window.clearTimeout(time));
  };

  const handleChange = (licensee) => {
    props.handleChange("licensee", licensee.label);
    props.handleChange("licenseeID", licensee.id);
    props.handleChange("licenseePath", licensee.path);
    props.handleChange("licenseeCode", licensee.code);
  };

  return (
    // <Tooltip arrow title="Select the name of the licensee here">
    <Tooltip arrow title={appText.T114}>
      <Grid item={true} xs={12}>
        <div id="licensee">
          <InputLabel className="field-label field-dropdown" required>
            {appText.T49}
          </InputLabel>
          <Autocomplete
            type={"single"}
            handleChange={handleChange}
            data={props.fetchedData}
            dataType={"licensee"}
            mapVariable={"title"}
            setFilterData={loadData}
            value={props.value}
            isLoading={false}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
